// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes avMode__page__background__off {
  from {
    background-color: var(--av-color-background, var(--color-background));
  }
  to {
    background-color: var(--color-background);
  }
}
@keyframes avMode__page__background__on {
  from {
    background-color: var(--color-background);
  }
  to {
    background-color: var(--av-color-background, var(--color-background));
  }
}
.av-mode.av-mode__page__background {
  background-color: var(--color-background);
}
.av-mode.av-mode__page__background.av-mode__off {
  animation: 1.2s avMode__page__background__off forwards;
}
.av-mode.av-mode__page__background.av-mode__on {
  animation: 1.2s avMode__page__background__on forwards;
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/always-visible-mode/av-mode__page__background.scss"],"names":[],"mappings":"AAUA;EACE;IARA,qEAAA;EAAA;EAYA;IARA,yCAAA;EADA;AACF;AAaA;EACE;IAdA,yCAAA;EAIA;EAcA;IAtBA,qEAAA;EAWA;AACF;AAgBE;EAxBA,yCAAA;AAWF;AAgBI;EACE,sDAAA;AAdN;AAiBI;EACE,qDAAA;AAfN","sourcesContent":["@use './av-mode__vars.scss' as *;\n\n@mixin on() {\n  background-color: var(--av-color-background, var(--color-background));\n}\n\n@mixin off() {\n  background-color: var(--color-background);\n}\n\n@keyframes avMode__page__background__off {\n  from {\n    @include on;\n  }\n\n  to {\n    @include off;\n  }\n}\n\n@keyframes avMode__page__background__on {\n  from {\n    @include off;\n  }\n\n  to {\n    @include on;\n  }\n}\n\n.av-mode {\n  &.av-mode__page__background {\n    @include off;\n\n    &.av-mode__off {\n      animation: $animation-duration avMode__page__background__off forwards;\n    }\n\n    &.av-mode__on {\n      animation: $animation-duration avMode__page__background__on forwards;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
